import React, {useState, useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/customised-breadcrumb.webp'
import customPackagingImg from '../Images/customised-form.webp'
import Industries from "../Components/Industries";
import { additionalProductGandhidham, products } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/ReCaptcha";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import createProductSchema from "../Schema/productSchema";
import ProductFaqs from "../Components/ProductFaqs";
import CustomisedProductIntro from "../Components/CustomisedProductIntro";
import CustomProjectNeeds from "../Components/CustomProjectNeeds";
import CustomiseProcess from "../Components/CustomiseProcess";

const CustomisedProductGandhidham=()=>{
    useEffect(() => {
            document.title =
              "Customised Packaging solution in Gandhidham | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Get reliable customize packaging solutions in Gandhidham, designed for machinery, equipment and industrial products with tailored sizes, materials and designs."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/products/customised-packaging-solution-in-gandhidham");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Customised Packaging solution in Gandhidham | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Get reliable customize packaging solutions in Gandhidham, designed for machinery, equipment and industrial products with tailored sizes, materials and designs."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/products/customised-packaging-solution-in-gandhidham");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/custom-product.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Customised Packaging solution in Gandhidham | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Get reliable customize packaging solutions in Gandhidham, designed for machinery, equipment and industrial products with tailored sizes, materials and designs."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/custom-product.webp"
            );
          }
          }, []);

const [formData, setFormData] = useState({
  fullName: "",
  companyName: "",
  phoneNumber: "",
  emailAddress: "",
  productType: "",
  packagingMaterial: "",
  length: "",
  height: "",
  width: "",
  qualityRequired: "",
  weightCapacity: "",
  referenceFile: null,
  additionalRequirements: "",
});

  const [loading, setLoading] = useState(false);
  const generateToken = useRecaptcha();

const handleChange = (e) => {

  const { name, value, files } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: files ? files[0] : value,
  }));
};

  // HANDLE SUBMIT

const handleSubmit = async (e) => {

  e.preventDefault();

  if (!formData.fullName)
    return toast.error("Please enter full name");

  if (!formData.companyName)
    return toast.error("Please enter company name");

  if (!formData.phoneNumber)
    return toast.error("Please enter phone number");

  if (!formData.emailAddress)
    return toast.error("Please enter email address");

  if (!formData.productType)
    return toast.error("Please select product type");

  if (!formData.packagingMaterial)
    return toast.error("Please select packaging material");

  const phoneRegex = /^[0-9]{10}$/;

  if (!phoneRegex.test(formData.phoneNumber)) {
    return toast.error(
      "Enter valid 10 digit phone number"
    );
  }

  setLoading(true);

  // ✅ GENERATE RECAPTCHA TOKEN
  generateToken(async (token) => {

    try {

      // ✅ VERIFY RECAPTCHA
      const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Le5nwAtAAAAABU2cKd_70tScz22RlaOz_yAfIVh"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      // ✅ BLOCK SPAM
      if (verifyRes.data.score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

      // ✅ EMAIL TEMPLATE
      const template = `
<div style="margin:0; padding:40px 0; background:#f4f7f6; font-family:Montserrat, Arial, sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center">

        <table 
          width="620" 
          cellpadding="0" 
          cellspacing="0" 
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 12px 40px rgba(0,0,0,0.08);
          "
        >

          <tr>
            <td
              style="
                height:8px;
                background:linear-gradient(90deg,#3E2101,#006257);
              "
            ></td>
          </tr>

          <!-- HEADER -->
          <tr>
            <td
              style="
                background:#DFF4F2;
                padding:38px 30px;
                text-align:center;
                border-bottom:1px solid #d6ebe8;
              "
            >

            
              <img 
                src='https://gurukrupawood.com/logo.png'
                alt='Gurukrupa Wood Pvt. Ltd.'
                style='max-width:170px; margin-bottom:20px;'
              />
         

              <h2
                style="
                  margin:0;
                  font-size:28px;
                  color:#3E2101;
                  font-weight:700;
                "
              >
                New Custom Packaging Inquiry
              </h2>

              <p
                style="
                  margin:12px 0 0;
                  color:#4b4b4b;
                  font-size:15px;
                  line-height:1.7;
                "
              >
                A new packaging inquiry has been submitted through the website.
              </p>

            </td>
          </tr>

          <!-- BODY -->
          <tr>
            <td style="padding:35px 30px;">

              <!-- CUSTOMER DETAILS -->
              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                style="
                  border:1px solid #ececec;
                  border-radius:14px;
                  overflow:hidden;
                  margin-bottom:24px;
                "
              >

                <tr>
                  <td
                    colspan="2"
                    style="
                      background:#f8fbfa;
                      padding:16px 20px;
                      border-left:4px solid #006257;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#006257;
                        font-size:18px;
                      "
                    >
                      Customer Details
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 20px; border-bottom:1px solid #ececec; width:50%;">
                    <span style="color:#777;">Full Name</span><br/>
                    <strong>${formData.fullName}</strong>
                  </td>

                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Company Name</span><br/>
                    <strong>${formData.companyName}</strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Phone Number</span><br/>
                    <strong>${formData.phoneNumber}</strong>
                  </td>

                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Email Address</span><br/>
                    <strong>${formData.emailAddress}</strong>
                  </td>
                </tr>

              </table>

              <!-- PACKAGING DETAILS -->
              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                style="
                  border:1px solid #ececec;
                  border-radius:14px;
                  overflow:hidden;
                  margin-bottom:24px;
                "
              >

                <tr>
                  <td
                    colspan="2"
                    style="
                      background:#f8fbfa;
                      padding:16px 20px;
                      border-left:4px solid #3E2101;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#3E2101;
                        font-size:18px;
                      "
                    >
                      Packaging Requirements
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 20px; border-bottom:1px solid #ececec; width:50%;">
                    <span style="color:#777;">Product Type</span><br/>
                    <strong>${formData.productType}</strong>
                  </td>

                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Packaging Material</span><br/>
                    <strong>${formData.packagingMaterial}</strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Length</span><br/>
                    <strong>${formData.length}</strong>
                  </td>

                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Width</span><br/>
                    <strong>${formData.width}</strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Height</span><br/>
                    <strong>${formData.height}</strong>
                  </td>

                  <td style="padding:18px 20px; border-bottom:1px solid #ececec;">
                    <span style="color:#777;">Weight Capacity</span><br/>
                    <strong>${formData.weightCapacity}</strong>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style="padding:18px 20px;">
                    <span style="color:#777;">Quality Required</span><br/>
                    <strong>${formData.qualityRequired}</strong>
                  </td>
                </tr>

              </table>

              <!-- MESSAGE -->
              <div>

                <h3
                  style="
                    margin:0 0 18px;
                    font-size:20px;
                    color:#006257;
                  "
                >
                  Additional Requirements
                </h3>

                <div
                  style="
                    background:#fafafa;
                    border:1px solid #ececec;
                    border-radius:14px;
                    padding:22px;
                    color:#25180D;
                    line-height:1.8;
                  "
                >
                  ${formData.additionalRequirements}
                </div>

              </div>

            </td>
          </tr>

          <!-- FOOTER -->
          <tr>
            <td
              style="
                background:#3E2101;
                padding:24px;
                text-align:center;
              "
            >

              <p
                style="
                  margin:0;
                  color:#ffffff;
                  font-size:13px;
                  line-height:1.7;
                "
              >
                Gurukrupa Wood Pvt. Ltd.<br/>
                Premium Industrial Wooden Packaging Solutions
              </p>

            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</div>
`;

      // ✅ FORM DATA
      const data = new FormData();

      data.append(
        "title",
        "Gurukrupa: Custom Packaging Form Gandhidham"
      );

      data.append(
        "to_email",
        "jignesh@gurukrupawood.com"
      );

      data.append("cc", "arkayappsseo@gmail.com, sales@arkayapps.com");

      data.append(
        "subject",
        "Gurukrupa: New Custom Product Enquiry Gandhidham"
      );

      data.append("template", template);

      // ✅ FILE
      if (formData.referenceFile) {

        data.append(
          "file",
          formData.referenceFile
        );
      }

      // ✅ SEND MAIL
      await axios.post(
        "https://api.sendmail.adhyaynam.in/send-mail/two",
        data,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      toast.success(
        "Inquiry submitted successfully 🚀"
      );

      // ✅ RESET
      setFormData({
        fullName: "",
        companyName: "",
        phoneNumber: "",
        emailAddress: "",
        productType: "",
        packagingMaterial: "",
        length: "",
        height: "",
        width: "",
        qualityRequired: "",
        weightCapacity: "",
        referenceFile: null,
        additionalRequirements: "",
      });

    } catch (error) {

      console.log(
        error.response?.data || error
      );

      toast.error(
        "Verification failed. Please try again!"
      );

    } finally {

      setLoading(false);

    }

  });

};

  const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Customised Package Solution in Gandhidham",
    url: "https://gurukrupawood.com/products/customised-packaging-solution-in-gandhidham"
  },
]);

const productSchema = createProductSchema({
  name: "Customised Package Solution in Gandhidham",
  description:"Get reliable customize packaging solutions in Gandhidham, designed for machinery, equipment and industrial products with tailored sizes, materials and designs.",
  url: "https://gurukrupawood.com/products/customised-packaging-solution-in-gandhidham",
});

    return(
        <>

        <SchemaMarkup data={breadcrumbSchema} />
        <SchemaMarkup data={productSchema} />

         <Breadcrumb
  pageName="Customised Packaging Solutions in Gandhidham"
  parentPage="Products in Gandhidham"
  bgImage={bgImg}
/>
        {/**INTRODUCTION SECTION */}
        <CustomisedProductIntro 
        heading="Packaging Built Around Your Requirements in Gandhidham"
        desc="Every product requires packaging that matches its size, weight, handling conditions and transportation needs. We provide Customised Packaging Solutions in Gandhidham designed to deliver maximum protection, durability and practical handling for industrial and export applications. From wooden pallets and crates to heavy-duty industrial boxes, we manufacture tailor-made packaging products based on your exact specifications. Our team considers product dimensions, load requirements, transportation conditions and protection needs to develop custom wooden packaging in Gandhidham that provides secure support throughout the supply chain."
        />

      {/**CUSTOM PROJECT NEEDS SECTION */}
      <CustomProjectNeeds />
   
      {/**PROCESS SECTION */}
      <CustomiseProcess 
      heading="From Requirement to Reliable Packaging in Gandhidham"
      />
      
        {/**INDUSTRIES SECTION */}
        <Industries 
        heading="Precision Packaging for Every Industrial Application in Gandhidham"
        />

          {/**FAQS SECTION */}
<ProductFaqs
  heading={additionalProductGandhidham[0].faqHeading}
  faqs={additionalProductGandhidham[0].faqs}
/>
        {/**FORM SECTION */}
        <section className="custom-packaging-section" id="custom-packaging-form">

  <div className="container">

    <div className="custom-packaging-grid">

      {/* LEFT IMAGE */}
      <motion.div
        className="custom-packaging-left"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{
          duration: 1,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{ once: true, amount: 0.2 }}
      >

        <motion.img
          src={customPackagingImg}
          alt="Custom Packaging Solutions | Gurukrupa Wood Pvt. Ltd."
        />

      </motion.div>

      {/* RIGHT FORM */}
      <motion.div
        className="custom-packaging-right"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{
          duration: 0.95,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{ once: true, amount: 0.2 }}
      >

        {/* SUBHEADING */}
        <motion.h3
          className="section-subheading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          LET’S BUILD THE RIGHT SOLUTION
        </motion.h3>

        {/* HEADING */}
        <motion.h2
          className="section-heading"
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.15,
            duration: 0.75,
          }}
          viewport={{ once: true }}
        >
         Have Ultimate Packaging Requirements in Gandhidham?
        </motion.h2>

        {/* FORM */}
        <motion.form
        onSubmit={handleSubmit}
          className="custom-packaging-form"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.08,
              },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >

          {/* ROW 1 */}
          <div className="custom-packaging-two-col">

            {[
              {
                label: "FULL NAME *",
                type: "text",
                placeholder: "Enter Full Name",
                name:"fullName"
              },
              {
                label: "COMPANY NAME *",
                type: "text",
                placeholder: "Enter Company Name",
                name:"companyName"
              },
            ].map((item, i) => (
              <motion.div
                className="custom-packaging-field"
                key={i}
                variants={{
                  hidden: {
                    opacity: 0,
                    y: 25,
                  },
                  visible: {
                    opacity: 1,
                    y: 0,
                  },
                }}
              >

                <label>{item.label}</label>

                <motion.input
                  type={item.type}
                  placeholder={item.placeholder}
                    name={item.name}
value={formData[item.name]}
onChange={handleChange}
                  whileFocus={{
                    scale: 1.01,
                  }}
                />

              </motion.div>
            ))}

          </div>

          {/* ROW 2 */}
          <div className="custom-packaging-two-col">

            {[
              {
                label: "PHONE NUMBER *",
                type: "tel",
                placeholder: "Enter Phone Number",
                name:"phoneNumber"
              },
              {
                label: "EMAIL ADDRESS *",
                type: "email",
                placeholder: "Enter Email Address",
                name:"emailAddress"
              },
            ].map((item, i) => (
              <motion.div
                className="custom-packaging-field"
                key={i}
                variants={{
                  hidden: {
                    opacity: 0,
                    y: 25,
                  },
                  visible: {
                    opacity: 1,
                    y: 0,
                  },
                }}
              >

                <label>{item.label}</label>

                <motion.input
                  type={item.type}
                  placeholder={item.placeholder}
                  whileFocus={{
                    scale: 1.01,
                  }}
                    name={item.name}
value={formData[item.name]}
onChange={handleChange}
                />

              </motion.div>
            ))}

          </div>

          {/* ROW 3 */}
          <div className="custom-packaging-two-col">

            {/* PRODUCT TYPE */}
            <motion.div
              className="custom-packaging-field"
              variants={{
                hidden: {
                  opacity: 0,
                  y: 25,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
            >

              <label>PRODUCT TYPE *</label>

              <motion.select
                whileFocus={{
                  scale: 1.01,
                }}
                  name="productType"
value={formData.productType}
onChange={handleChange}
              >
                <option>
                  Select product for customisation
                </option>

               {products.map((item,i)=>(
                <option key={i}>{item.title}</option>
               ))}
              </motion.select>

            </motion.div>

            {/* MATERIAL */}
            <motion.div
              className="custom-packaging-field"
              variants={{
                hidden: {
                  opacity: 0,
                  y: 25,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
            >

              <label>PACKAGING MATERIAL *</label>

              <motion.select
                whileFocus={{
                  scale: 1.01,
                }}
                 name="packagingMaterial"
value={formData.packagingMaterial}
onChange={handleChange}
              >
                <option>
                  Select packaging material
                </option>

                <option>
                  Pine Wood
                </option>

                <option>
                  Hardwood
                </option>

                <option>
                  Plywood
                </option>

                <option>Mixed Wood</option>

                <option>Heat Treated Wood</option>

                <option>Need Suggestion</option>

              </motion.select>

            </motion.div>

          </div>

         {/* DIMENSIONS */}
<motion.div
  className="custom-packaging-field"
  variants={{
    hidden: {
      opacity: 0,
      y: 25,
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  }}
>

  <label>PRODUCT DIMENSION</label>

  <div className="custom-packaging-three-col">

    {[
      {
        placeholder: "Length",
        name: "length",
      },
      {
        placeholder: "Height",
        name: "height",
      },
      {
        placeholder: "Width",
        name: "width",
      },
    ].map((item, i) => (
      <motion.input
        key={i}
        type="text"
        placeholder={item.placeholder}
        whileFocus={{
          scale: 1.01,
        }}
        name={item.name}
        value={formData[item.name]}
        onChange={handleChange}
      />
    ))}

  </div>

</motion.div>
          {/* ROW 4 */}
          <div className="custom-packaging-two-col">

            {[
              {
                label: "QUALITY REQUIRED",
                placeholder: "Enter Preferred Quality",
                name:"qualityRequired"
              },
              {
                label: "WEIGHT CAPACITY",
                placeholder:
                  "Enter Preferred Weight Quality",
                  name:"weightCapacity"
              },
            ].map((item, i) => (
              <motion.div
                className="custom-packaging-field"
                key={i}
                variants={{
                  hidden: {
                    opacity: 0,
                    y: 25,
                  },
                  visible: {
                    opacity: 1,
                    y: 0,
                  },
                }}
              >

                <label>{item.label}</label>

                <motion.input
                  type="text"
                  placeholder={item.placeholder}
                  whileFocus={{
                    scale: 1.01,
                  }}
                   name={item.name}
value={formData[item.name]}
onChange={handleChange}
                />

              </motion.div>
            ))}

          </div>

          {/* FILE */}
         {/* FILE */}
<motion.div
  className="custom-packaging-field"
  variants={{
    hidden: {
      opacity: 0,
      y: 25,
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  }}
>

  <label>UPLOAD REFERENCE FILE</label>

  <motion.div
    className="custom-packaging-upload"
    whileHover={{
      scale: 1.01,
    }}
  >

    <input
      type="file"
      name="referenceFile"
      onChange={handleChange}
    />

  </motion.div>

</motion.div>

          {/* MESSAGE */}
          <motion.div
            className="custom-packaging-field"
            variants={{
              hidden: {
                opacity: 0,
                y: 25,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
          >

            <label>ADDITIONAL REQUIREMENTS</label>

            <motion.textarea
              placeholder="Write additional Requirements if any."
                 name="additionalRequirements"
value={formData.additionalRequirements}
onChange={handleChange}
              whileFocus={{
                scale: 1.01,
              }}
            ></motion.textarea>

          </motion.div>

          {/* BUTTON */}
          <motion.button
            type="submit"
            disabled={loading}
            className="green-btn"
            initial={{
              opacity: 0,
              scale: 0.9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              delay: 0.45,
              duration: 0.5,
            }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -2,
            }}
            whileTap={{
              scale: 0.97,
            }}
          >
          {loading ? "Submitting..." : "Submit"}
          </motion.button>

        </motion.form>

      </motion.div>

    </div>

  </div>
    <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={true}
    closeOnClick
    pauseOnHover
    theme="light"
  />
</section>
        </>
    )
}
export default CustomisedProductGandhidham;